import Box from "@material-ui/core/Box";

type TabPanelsProps = {
    children: React.ReactNode
}

export default function TabPanels({ children }: TabPanelsProps) {
    return (
        <Box>{children}</Box>
    );
}